<!--Topbar-->
<div class="navbar-custom">
  <div [class]="containerClass">
    <ul class="list-unstyled topnav-menu float-end mb-0">
      <li
        class="dropdown notification-list"
        *ngIf="showTenantSelector()"
        ngbDropdown
      >
        <div class="nav-link">
          <button
            class="form-select tenant-select tenant-dropdown-toggle"
            type="button"
            ngbDropdownToggle
          >
            {{ getSelectedTenantName() }}
          </button>
          <div ngbDropdownMenu class="dropdown-menu-end tenant-dropdown-menu">
            <ng-container *ngFor="let tenant of tenants; let i = index">
              <a
                href="javascript:void(0)"
                class="dropdown-item tenant-dropdown-item"
                [class.active]="tenant.id === selectedTenant"
                (click)="selectTenant(tenant.id)"
                ngbDropdownItem
              >
                {{ tenant.name }}
              </a>
              <div
                class="dropdown-divider"
                *ngIf="i < tenants.length - 1"
              ></div>
            </ng-container>
          </div>
        </div>
      </li>
      <li class="dropdown notification-list">
        <div
          class="nav-link right-bar-toggle waves-effect waves-light"
          style="padding-right: 0"
        >
          <div class="form-switch">
            <label class="switch">
              <input
                type="checkbox"
                (click)="toggleTour()"
                [checked]="tourState"
              />
              <span
                class="slider round"
                [ngClass]="layoutColor === 'dark' ? 'dark' : 'light'"
              ></span>
            </label>
          </div>
        </div>
      </li>
      <li class="dropdown notification-list">
        <div
          class="nav-link right-bar-toggle waves-effect waves-light"
          style="padding-left: 5px"
        >
          <span class="tour-info">
            {{ "layout.topbar.tour" | translate }}
            <strong>{{ tourStateValue }}</strong></span
          >
        </div>
      </li>
      <li class="notification-list topbar-dropdown profile" ngbDropdown>
        <a
          class="nav-link dropdown-toggle nav-user me-0 waves-effect waves-light"
          href="javascript:void(0)"
          role="button"
          ngbDropdownToggle
        >
          <span
            class="avatar-initials rounded-circle"
            [ngClass]="layoutColor === 'dark' ? 'dark' : 'light'"
          >
            {{ getUserInitials() }}
          </span>
          <span class="pro-user-name ms-1">
            {{ currentUser?.name }}
            <i class="mdi mdi-chevron-down" style="font-size: x-large"></i>
          </span>
        </a>
        <div ngbDropdownMenu class="dropdown-menu-end profile-dropdown">
          <ng-container *ngFor="let option of profileOptions; let i = index">
            <div
              class="dropdown-divider"
              *ngIf="i === profileOptions.length - 1"
            ></div>
            <a
              [routerLink]="option.redirectTo"
              class="notify-item"
              ngbDropdownItem
            >
              <i [class]="option.icon"></i>
              <span style="cursor: default">{{
                option.label | translate
              }}</span>
            </a>
          </ng-container>
        </div>
      </li>
      <li
        class="notification-list topbar-dropdown"
        #notificationsDropdownContainer
      >
        <div
          ngbDropdown
          #notificationsDropdown="ngbDropdown"
          [autoClose]="false"
        >
          <button
            ngbDropdownToggle
            class="nav-link drop-arrow-none notification-button"
            data-bs-toggle="dropdown"
            data-bs-offset="0,25"
            type="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i
              class="mdi mdi-bell-outline"
              [ngClass]="{
                'animate-bounce': getUnreadNotificationsCount() > 0
              }"
              style="font-size: x-large"
            ></i>
            <span
              class="noti-icon-badge"
              *ngIf="getUnreadNotificationsCount() > 0"
            >
              {{ getUnreadNotificationsCount() }}
            </span>
          </button>

          <div
            ngbDropdownMenu
            class="p-0 dropdown-menu-end dropdown-menu-lg"
            style="width: max-content; min-width: 300px; max-width: 350px"
          >
            <div class="p-2 border-bottom border-light">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="m-0 fw-semibold">
                    {{ "layout.topbar.notifications.title" | translate }}
                  </h5>
                </div>
                <div class="col-auto">
                  <div ngbDropdown class="dropdown">
                    <a
                      ngbDropdownToggle
                      class="drop-arrow-none link-dark"
                      data-bs-toggle="dropdown"
                      data-bs-offset="0,15"
                      aria-expanded="false"
                    >
                      <i class="mdi mdi-dots-vertical align-middle"></i>
                    </a>
                    <div ngbDropdownMenu class="dropdown-menu-end py-2">
                      <a
                        href="javascript:void(0);"
                        (click)="markAllAsRead($event)"
                        style="cursor: pointer; font-size: 12px"
                        class="dropdown-item"
                        *ngIf="getUnreadNotificationsCount() > 0"
                        >{{
                          "layout.topbar.notifications.mark_all_as_read"
                            | translate
                        }}</a
                      >

                      <a
                        href="javascript:void(0);"
                        routerLink="/profile"
                        ngbDropdownItem
                        style="cursor: pointer; font-size: 12px"
                        (click)="closeNotificationsDropdown()"
                        >{{
                          "layout.topbar.notifications.settings" | translate
                        }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ngx-simplebar
              class="position-relative z-2 card shadow-none rounded-0"
              style="margin-bottom: 0"
              data-simplebar
            >
              <div
                class="dropdown-item notification-item py-1 text-start border-bottom border-light"
                [ngClass]="{ 'notification-unread': !notification.isRead }"
                *ngFor="let notification of getUnreadNotifications()"
                [id]="'notification-' + notification.id"
              >
                <a
                  class="text-decoration-none text-reset"
                  href="javascript:void(0);"
                  (click)="
                    navigateToSectionByNotificationType(notification.type)
                  "
                >
                  <span class="d-flex align-items-center">
                    <span class="flex-grow-1 text-muted">
                      <p
                        class="fw-light text-wrap mb-1"
                        style="font-size: 14px"
                      >
                        {{ notification.title }}
                      </p>
                      <span
                        class="text-muted fw-semibold"
                        style="font-size: 12px"
                        >{{
                          notification.createdAt | date : "dd/MM/yyyy HH:mm"
                        }}</span
                      >
                    </span>
                    <span class="notification-item-close">
                      <button
                        type="button"
                        class="btn btn-ghost-danger rounded-circle btn-sm btn-icon mark-read-button"
                        (click)="markAsRead(notification.id, $event)"
                        [title]="
                          'pages.modules.notifications.mark_as_read' | translate
                        "
                      >
                        <i
                          class="mdi mdi-email-outline"
                          style="font-size: 18px"
                          [title]="
                            'pages.modules.notifications.mark_as_read'
                              | translate
                          "
                        ></i>
                      </button>
                    </span>
                  </span>
                </a>
              </div>
              <p
                class="fw-light my-0 py-2"
                style="cursor: default"
                *ngIf="getUnreadNotifications().length === 0"
              >
                {{
                  "layout.topbar.notifications.no_unread_notifications"
                    | translate
                }}
              </p>
            </ngx-simplebar>
            <div class="p-2 border-top border-light">
              <a
                href="javascript:void(0);"
                routerLink="/notifications"
                class="fw-semibold text-decoration-none"
                (click)="closeNotificationsDropdown()"
              >
                {{ "layout.topbar.notifications.view_all" | translate }}
              </a>
            </div>
          </div>
        </div>
      </li>
      <li class="dropdown notification-list">
        <div class="nav-link">
          <i
            class="mdi theme-switcher-icon"
            [ngClass]="
              layoutColor === 'dark' ? 'mdi-weather-sunny' : 'mdi-weather-night'
            "
            (click)="toggleColorScheme()"
            style="font-size: x-large"
          ></i>
        </div>
      </li>
    </ul>

    <!--Logo-->
    <div class="logo-box">
      <a routerLink="/" class="logo text-left">
        <span class="logo-sm">
          <img
            [src]="
              layoutColor === 'dark'
                ? 'assets/images/logos/logo-light-sm.svg'
                : 'assets/images/logos/logo-dark-sm.svg'
            "
            alt="{{ 'layout.common.logo.direct_cayc' | translate }}"
            height="28"
          />
        </span>
        <span class="logo-lg">
          <img
            [src]="
              layoutColor === 'dark'
                ? 'assets/images/logos/logo-light.svg'
                : 'assets/images/logos/logo-dark.svg'
            "
            alt="{{ 'layout.common.logo.direct_cayc' | translate }}"
            height="32"
          />
        </span>
      </a>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left mb-0">
      <!--Mobile Menu-->
      <li *ngIf="layoutType === 'vertical'">
        <button
          class="button-menu-mobile disable-btn waves-effect open-left"
          (click)="toggleMobileMenu($event)"
        >
          <i class="fe-menu"></i>
        </button>
      </li>
      <li *ngIf="layoutType === 'horizontal'">
        <a
          class="navbar-toggle nav-link horizontal-toggle"
          (click)="toggleMobileMenu($event)"
        >
          <div class="lines">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </a>
      </li>
      <!--Mobile Menu-->
      <!--Page Title-->
      <li *ngIf="layoutType === 'vertical'">
        <h4 class="page-title-main">{{ pageTitle }}</h4>
      </li>
      <!--Page Title-->
    </ul>

    <div class="clearfix"></div>
  </div>
</div>
<!--Topbar-->
